import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocaleStateService } from '@ui/features/locale/presentation/services/locale-state.service';

// Cloudflare (delante de la API) ignora Vary: X-Language y cachea por URL: sin
// diferenciar la URL, un visitante en "en" puede recibir la respuesta cacheada
// que otro pidio en "es" (o al reves) para recursos con texto traducido
// (system_information/currency_information). "sort=id" no cambia los datos,
// solo separa la cache-key en el CDN.
// ponytail: parche de origen mientras se agrega X-Language a la Cache Key de
// Cloudflare; sacar cuando esa Cache Rule este activa (DEV-2513).
const TRANSLATED_RESOURCE_PATTERN: RegExp = /system_information|\/information(?:\?|$)/;

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    public constructor(private readonly localeStateService: LocaleStateService) {}

    public intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        const locale: string | null = this.localeStateService.getLocale()?.toString() ?? null;
        if (locale === null) {
            return next.handle(request);
        }

        const needsCacheBusting: boolean =
            locale.startsWith('en') &&
            request.method === 'GET' &&
            TRANSLATED_RESOURCE_PATTERN.test(request.url + request.urlWithParams);

        return next.handle(
            request.clone({
                setHeaders: { 'X-Language': locale },
                setParams: needsCacheBusting ? { sort: 'id' } : {},
            }),
        );
    }
}
